import React from 'react';

interface AdminSectionPageProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
}

const AdminSectionPage: React.FC<AdminSectionPageProps> = ({ title, description, icon }) => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-base-content mb-2 flex items-center gap-3">
        {icon}
        {title}
      </h1>
      <p className="text-base-content opacity-70">{description}</p>
      <div className="mt-6 card bg-base-100 shadow">
        <div className="card-body">
          <p className="text-sm text-base-content opacity-70">
            This admin section is scaffolded and ready for implementation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminSectionPage;
